export default {
  data () {
    return {
      statesMixin_state_license_states: [
        { abbreviation: 'AL', name: 'Alabama' },
        { abbreviation: 'AK', name: 'Alaska' },
        { abbreviation: 'AZ', name: 'Arizona' },
        { abbreviation: 'AR', name: 'Arkansas' },
        { abbreviation: 'AS', name: 'American Samoa' },
        { abbreviation: 'CA', name: 'California' },
        { abbreviation: 'CO', name: 'Colorado' },
        { abbreviation: 'CT', name: 'Connecticut' },
        { abbreviation: 'DE', name: 'Delaware' },
        { abbreviation: 'DC', name: 'District of Columbia' },
        { abbreviation: 'FM', name: 'States of Micronesia' },
        { abbreviation: 'FL', name: 'Florida' },
        { abbreviation: 'GA', name: 'Georgia' },
        { abbreviation: 'GU', name: 'Guam' },
        { abbreviation: 'HI', name: 'Hawaii' },
        { abbreviation: 'ID', name: 'Idaho' },
        { abbreviation: 'IL', name: 'Illinois' },
        { abbreviation: 'IN', name: 'Indiana' },
        { abbreviation: 'IA', name: 'Iowa' },
        { abbreviation: 'KS', name: 'Kansas' },
        { abbreviation: 'KY', name: 'Kentucky' },
        { abbreviation: 'LA', name: 'Louisiana' },
        { abbreviation: 'ME', name: 'Maine' },
        { abbreviation: 'MD', name: 'Maryland' },
        { abbreviation: 'MA', name: 'Massachusetts' },
        { abbreviation: 'MH', name: 'Marshall Islands' },
        { abbreviation: 'MI', name: 'Michigan' },
        { abbreviation: 'MN', name: 'Minnesota' },
        { abbreviation: 'MS', name: 'Mississippi' },
        { abbreviation: 'MO', name: 'Missouri' },
        { abbreviation: 'MT', name: 'Montana' },
        { abbreviation: 'NE', name: 'Nebraska' },
        { abbreviation: 'NV', name: 'Nevada' },
        { abbreviation: 'NH', name: 'New Hampshire' },
        { abbreviation: 'NJ', name: 'New Jersey' },
        { abbreviation: 'NM', name: 'New Mexico' },
        { abbreviation: 'NY', name: 'New York' },
        { abbreviation: 'NC', name: 'North Carolina' },
        { abbreviation: 'ND', name: 'North Dakota' },
        { abbreviation: 'MP', name: 'Mariana Islands' },
        { abbreviation: 'OH', name: 'Ohio' },
        { abbreviation: 'OK', name: 'Oklahoma' },
        { abbreviation: 'OR', name: 'Oregon' },
        { abbreviation: 'PA', name: 'Pennsylvania' },
        { abbreviation: 'PR', name: 'Puerto Rico' },
        { abbreviation: 'PW', name: 'Republic of Palau' },
        { abbreviation: 'RI', name: 'Rhode Island' },
        { abbreviation: 'SC', name: 'South Carolina' },
        { abbreviation: 'SD', name: 'South Dakota' },
        { abbreviation: 'TN', name: 'Tennessee' },
        { abbreviation: 'TX', name: 'Texas' },
        { abbreviation: 'UT', name: 'Utah' },
        { abbreviation: 'VT', name: 'Vermont' },
        { abbreviation: 'VI', name: 'Virgin Islands' },
        { abbreviation: 'VA', name: 'Virginia' },
        { abbreviation: 'WA', name: 'Washington' },
        { abbreviation: 'WV', name: 'West Virginia' },
        { abbreviation: 'WI', name: 'Wisconsin' },
        { abbreviation: 'WY', name: 'Wyoming' },
        { abbreviation: 'US', name: 'Nationwide' }
      ],
      statesMixin_states: [
        {
          abbr_full_name: '',
          name: '',
          abbr: ''
        },
        {
          abbr_full_name: 'AA - Armed Forces of the Americas',
          name: 'Armed Forces of the Americas',
          abbr: 'AA'
        },
        {
          abbr_full_name: 'AE - Armed Forces of Europe',
          name: 'Armed Forces of Europe',
          abbr: 'AE'
        },
        {
          abbr_full_name: 'AK - Alaska',
          name: 'Alaska',
          abbr: 'AK'
        },
        {
          abbr_full_name: 'AL - Alabama',
          name: 'Alabama',
          abbr: 'AL'
        },
        {
          abbr_full_name: 'AP - Armed Forces of the Pacific',
          name: 'Armed Forces of the Pacific',
          abbr: 'AP'
        },
        {
          abbr_full_name: 'AR - Arkansas',
          name: 'Arkansas',
          abbr: 'AR'
        },
        {
          abbr_full_name: 'AS - American Samoa',
          name: 'American Samoa',
          abbr: 'AS'
        },
        {
          abbr_full_name: 'AZ - Arizona',
          name: 'Arizona',
          abbr: 'AZ'
        },
        {
          abbr_full_name: 'CA - California',
          name: 'California',
          abbr: 'CA'
        },
        {
          abbr_full_name: 'CO - Colorado',
          name: 'Colorado',
          abbr: 'CO'
        },
        {
          abbr_full_name: 'CT - Connecticut',
          name: 'Connecticut',
          abbr: 'CT'
        },
        {
          abbr_full_name: 'DC - District of Columbia',
          name: 'District of Columbia',
          abbr: 'DC'
        },
        {
          abbr_full_name: 'DE - Delaware',
          name: 'Delaware',
          abbr: 'DE'
        },
        {
          abbr_full_name: 'FL - Florida',
          name: 'Florida',
          abbr: 'FL'
        },
        {
          abbr_full_name: 'FM - Federated States of Micronesia',
          name: 'States of Micronesia',
          abbr: 'FM'
        },
        {
          abbr_full_name: 'GA - Georgia',
          name: 'Georgia',
          abbr: 'GA'
        },
        {
          abbr_full_name: 'GU - Guam',
          name: 'Guam',
          abbr: 'GU'
        },
        {
          abbr_full_name: 'HI - Hawaii',
          name: 'Hawaii',
          abbr: 'HI'
        },
        {
          abbr_full_name: 'IA - Iowa',
          name: 'Iowa',
          abbr: 'IA'
        },
        {
          abbr_full_name: 'ID - Idaho',
          name: 'Idaho',
          abbr: 'ID'
        },
        {
          abbr_full_name: 'IL - Illinois',
          name: 'Illinois',
          abbr: 'IL'
        },
        {
          abbr_full_name: 'IN - Indiana',
          name: 'Indiana',
          abbr: 'IN'
        },
        {
          abbr_full_name: 'KS - Kansas',
          name: 'Kansas',
          abbr: 'KS'
        },
        {
          abbr_full_name: 'KY - Kentucky',
          name: 'Kentucky',
          abbr: 'KY'
        },
        {
          abbr_full_name: 'LA - Louisiana',
          name: 'Louisiana',
          abbr: 'LA'
        },
        {
          abbr_full_name: 'MA - Massachusetts',
          name: 'Massachusetts',
          abbr: 'MA'
        },
        {
          abbr_full_name: 'MD - Maryland',
          name: 'Maryland',
          abbr: 'MD'
        },
        {
          abbr_full_name: 'ME - Maine',
          name: 'Maine',
          abbr: 'ME'
        },
        {
          abbr_full_name: 'MH - Marshall Islands',
          name: 'Marshall Islands',
          abbr: 'MH'
        },
        {
          abbr_full_name: 'MI - Michigan',
          name: 'Michigan',
          abbr: 'MI'
        },
        {
          abbr_full_name: 'MN - Minnesota',
          name: 'Minnesota',
          abbr: 'MN'
        },
        {
          abbr_full_name: 'MO - Missouri',
          name: 'Missouri',
          abbr: 'MO'
        },
        {
          abbr_full_name: 'MP - Mariana Islands',
          name: 'Mariana Islands',
          abbr: 'MP'
        },
        {
          abbr_full_name: 'MS - Mississippi',
          name: 'Mississippi',
          abbr: 'MS'
        },
        {
          abbr_full_name: 'MT - Montana',
          name: 'Montana',
          abbr: 'MT'
        },
        {
          abbr_full_name: 'NC - North Carolina',
          name: 'North Carolina',
          abbr: 'NC'
        },
        {
          abbr_full_name: 'ND - North Dakota',
          name: 'North Dakota',
          abbr: 'ND'
        },
        {
          abbr_full_name: 'NE - Nebraska',
          name: 'Nebraska',
          abbr: 'NE'
        },
        {
          abbr_full_name: 'NH - New Hampshire',
          name: 'New Hampshire',
          abbr: 'NH'
        },
        {
          abbr_full_name: 'NJ - New Jersey',
          name: 'New Jersey',
          abbr: 'NJ'
        },
        {
          abbr_full_name: 'NM - New Mexico',
          name: 'New Mexico',
          abbr: 'NM'
        },
        {
          abbr_full_name: 'NV - Nevada',
          name: 'Nevada',
          abbr: 'NV'
        },
        {
          abbr_full_name: 'NY - New York',
          name: 'New York',
          abbr: 'NY'
        },
        {
          abbr_full_name: 'OH - Ohio',
          name: 'Ohio',
          abbr: 'OH'
        },
        {
          abbr_full_name: 'OK - Oklahoma',
          name: 'Oklahoma',
          abbr: 'OK'
        },
        {
          abbr_full_name: 'OR - Oregon',
          name: 'Oregon',
          abbr: 'OR'
        },
        {
          abbr_full_name: 'PA - Pennsylvania',
          name: 'Pennsylvania',
          abbr: 'PA'
        },
        {
          abbr_full_name: 'PR - Puerto Rico',
          name: 'Puerto Rico',
          abbr: 'PR'
        },
        {
          abbr_full_name: 'PW - Republic of Palau',
          name: 'Republic of Palau',
          abbr: 'PW'
        },
        {
          abbr_full_name: 'RI - Rhode Island',
          name: 'Rhode Island',
          abbr: 'RI'
        },
        {
          abbr_full_name: 'SC - South Carolina',
          name: 'South Carolina',
          abbr: 'SC'
        },
        {
          abbr_full_name: 'SD - South Dakota',
          name: 'South Dakota',
          abbr: 'SD'
        },
        {
          abbr_full_name: 'TN - Tennessee',
          name: 'Tennessee',
          abbr: 'TN'
        },
        {
          abbr_full_name: 'TX - Texas',
          name: 'Texas',
          abbr: 'TX'
        },
        {
          abbr_full_name: 'UT - Utah',
          name: 'Utah',
          abbr: 'UT'
        },
        {
          abbr_full_name: 'VA - Virginia',
          name: 'Virginia',
          abbr: 'VA'
        },
        {
          abbr_full_name: 'VI - Virgin Islands',
          name: 'Virgin Islands',
          abbr: 'VI'
        },
        {
          abbr_full_name: 'VT - Vermont',
          name: 'Vermont',
          abbr: 'VT'
        },
        {
          abbr_full_name: 'WA - Washington',
          name: 'Washington',
          abbr: 'WA'
        },
        {
          abbr_full_name: 'WI - Wisconsin',
          name: 'Wisconsin',
          abbr: 'WI'
        },
        {
          abbr_full_name: 'WV - West Virginia',
          name: 'West Virginia',
          abbr: 'WV'
        },
        {
          abbr_full_name: 'WY - Wyoming',
          name: 'Wyoming',
          abbr: 'WY'
        },
        {
          abbr_full_name: 'US - Nationwide',
          name: 'Nationwide',
          abbr: 'US'
        }
      ]
    }
  },
  methods: {
    StatesMixin_getAllAbbrFullNames () {
      return this.statesMixin_states
        .map(state => state.abbr_full_name)
    },
    StatesMixin_getDropDownOptions (exclude = []) {
      return this.statesMixin_states
        .map(state => {
          if (exclude.includes(state.abbr)) return null

          return {
            disabled: false,
            value: state.abbr,
            name: state.name,
            text: state.abbr_full_name
          }
        })
        .filter(state => !!state)
    },
    StatesMixin_getNameByAbbr (value) {
      if (!value) return

      const statesMatched = this.statesMixin_states
        .filter(state => state.abbr.toLowerCase() === value.toLowerCase())
        .map(state => state.name)
      if (statesMatched.length) return statesMatched[0]
    },
    StatesMixin_getAbbrFullNameByAbbr (value) {
      if (!value) return

      const statesMatched = this.statesMixin_states
        .filter(state => state.abbr.toLowerCase() === value.toLowerCase())
        .map(state => state.abbr_full_name)
      if (statesMatched.length) return statesMatched[0]
    },
    StatesMixin_getAbbrByFullName (value, fuzzy) {
      if (!value) return
      let statesMatched
      if (fuzzy) {
        statesMatched = this.statesMixin_states
          .filter(state => state.name.toLowerCase().includes(value.toLowerCase()))
          .map(state => state.abbr)
      } else {
        statesMatched = this.statesMixin_states
          .filter(state => state.name.toLowerCase() === value.toLowerCase())
          .map(state => state.abbr)
      }

      if (statesMatched.length) return statesMatched[0]
    }
  }
}
